import 'bootstrap3/dist/css/bootstrap.css';
import { alert } from 'util/alert'
// 
// should be the only scss imported
//
import 'themes/basic/style.scss';

import React from 'react'
import { Provider } from 'react-redux'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import classnames from 'classnames';
import 'themes/basic/style.scss'; 

import store from './store'
import Routes from './routes'

import keydown, { ALL_KEYS } from 'react-keydown';

const history = syncHistoryWithStore(browserHistory, store)

class App extends React.Component {
  componentWillMount() {
    document.body.className += ' locale-' + __localeName();
  }

  render() {
    return (
      <div className={classnames('app-wrapper')}>
        <Provider store={store}>
          <Routes history={history} />
        </Provider>
      </div>
    )
  }
}

// for safari
window.addEventListener('unhandledrejection', event => {
  
  // Prevent error output on the console:
  event.preventDefault();
  
  console.error('Reason: ', event.reason, event);
  

});

export default App



// WEBPACK FOOTER //
// ./src/App.js